import Echo, { Channel as EchoChannel } from 'laravel-echo';
import Pusher from 'pusher-js';

import { generateUrl } from './base-url';
import { getBearerToken } from './bearer-token';

export type Channel = EchoChannel;
export type UnsubscribeCallback = () => Channel | undefined;

export const echo = import.meta.env.VITE_PUSHER_APP_KEY
  ? new Echo({
      broadcaster: 'pusher',
      key: import.meta.env.VITE_PUSHER_APP_KEY,
      client: new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
        channelAuthorization: {
          transport: 'ajax',
          endpoint: generateUrl('broadcasting/auth'),
          headersProvider: () => ({
            Authorization: getBearerToken(),
          }),
        },
      }),
    })
  : undefined;
